import { FR_GREY_300, FR_IL_RED, FR_PR_BLACK, FR_PR_BLUE, FR_PR_WHITE } from '@shared/styles/vars';
import { CSSObjectWithLabel, GroupBase, OptionProps } from 'react-select';
import { Option } from '../interfaces/option.interface';

export const controlStyles = (base: CSSObjectWithLabel, isInvalid?: boolean) => ({
  ...base,
  '&:focus': { border: `0.1rem solid ${isInvalid ? FR_IL_RED : FR_PR_BLUE}` },
  '&:hover': { border: `0.1rem solid ${isInvalid ? FR_IL_RED : FR_GREY_300}` },
  'border': `0.1rem solid ${isInvalid ? FR_IL_RED : FR_GREY_300}`,
  'minHeight': '4.8rem',
});

export const optionStyles = (
  base: CSSObjectWithLabel,
  props: OptionProps<Option, false, GroupBase<Option>> | OptionProps<Option, true, GroupBase<Option>>,
): CSSObjectWithLabel => ({
  ...base,
  '&:hover': { backgroundColor: FR_GREY_300, color: FR_PR_BLACK },
  'backgroundColor': props.isSelected ? FR_PR_BLUE : 'transparent',
  'color': props.isSelected ? FR_PR_WHITE : FR_PR_BLACK,
});
